import React from 'react'

function ProfilePage() {
  return (
    <>
      <section className="flat-title2 ">
        <div className="container7">
          <div className="row">
            <div className="col-lg-12">
              <div className="title-group fs-30 lh-45 fw-7">Profile</div>
            </div>
          </div>
        </div>
      </section>
      <section className="flat-profile flat-upload-photo">
        <div className="container7">
          <div className="row">
            <div className="col-lg-12">
              <div className="tf-uploads bg-white">
                <h3 className="titles">Avatar</h3>
                <div className="wrap-upload ">
                  <div className="box-upload flex">
                    <div className="img-up relative">
                      <img
                        className="avatar"
                        id="profileimg"
                        src="/assets/images/author/author-dashboard-profile2.jpg"
                        alt=""
                      />
                    </div>
                    <div className="content">
                      <div className="subtitle">Téléverser une nouvelle image</div>
                      <div
                        className="button-box relative flex align-center"
                        id="upload-profile"
                      >
                        <a href="#" className="btn-upload sc-button">
                          <span className="fw-14 fw-6">Sélectionner</span>{" "}
                        </a>
                        <input
                          id="tf-upload-img"
                          type="file"
                          name="profile"
                          required=""
                        />
                        <div className="">Aucun fichier choisi</div>
                      </div>
                      <p className="fs-12 lh-18">JPEG 100x100</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="tf-infomation bg-white">
                <h3 className="titles">Informations</h3>
                <div className="info-box info-wg">
                  <div className="inner-1">
                    <fieldset>
                      <label className="title-user fw-6">Nom complet</label>
                      <input
                        type="text"
                        placeholder="Ralph Edwards"
                        className="input-form"
                        required=""
                      />
                    </fieldset>
                  </div>
                  <div className="inner-2">
                    <fieldset className="message-wrap">
                      <label className="fw-6">Description</label>
                      <textarea
                        id="comment-message"
                        name="message"
                        rows={4}
                        tabIndex={4}
                        aria-required="true"
                        defaultValue={""}
                      />
                    </fieldset>
                  </div>
                  <div className="inner-3 inner form-wg flex">
                    <div className="wg-box3 select-group">
                      <fieldset>
                        <label className="title-user fw-6">Votre entreprise</label>
                        <input
                          type="tel"
                          placeholder=" "
                          className="input-form"
                          required=""
                        />
                      </fieldset>
                    </div>
                    <div className="wg-box3 select-group">
                      <fieldset>
                        <label className="title-user fw-6">Emploi</label>
                        <input
                          type="text"
                          placeholder=" "
                          className="input-form"
                          required=""
                        />
                      </fieldset>
                    </div>
                    <div className="wg-box3 select-group">
                      <fieldset>
                        <label className="title-user fw-6">Adresse e-mail</label>
                        <input
                          type="email"
                          placeholder=" "
                          className="input-form"
                          required=""
                        />
                      </fieldset>
                    </div>
                    <div className="wg-box3 select-group">
                      <fieldset>
                        <label className="title-user fw-6">Votre téléphone</label>
                        <input
                          type="tel"
                          placeholder=" "
                          className="input-form"
                          required=""
                        />
                      </fieldset>
                    </div>
                  </div>
                  <div className="inner-4 inner">
                    <fieldset>
                      <label className="title-user fw-6">Localisation</label>
                      <input
                        type="text"
                        placeholder="Ralph Edwards"
                        className="input-form"
                        required=""
                      />
                    </fieldset>
                  </div>
                  <div className="inner-6 inner">
                    <fieldset>
                      <label className="title-user fw-6">Réseaux sociaux</label>
                      <input
                        type="url"
                        placeholder="url"
                        className="input-form"
                        required=""
                      />
                    </fieldset>
                  </div>
                  <div className="wrap-button tf-save">
                    <button className="sc-button" name="submit" type="submit">
                      <span>Enregistrer &amp; Mettre à jour</span>
                    </button>
                  </div>
                </div>
              </div>

              
            </div>
          </div>
        </div>
      </section>
    </>

  )
}

export default ProfilePage